"use client";

import { ChefHat, Coffee, UtensilsCrossed, Fish, Wine, Salad, Flame, Star } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MenuCategories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const categories = [{
    id: "appetizers",
    title: "Appetizers, Nachos, Salad, & Soups",
    icon: UtensilsCrossed,
    menuItems: [{
      id: "guacajete",
      name: "Guacajete",
      description: "Guacamole made fresh with avocados, onions, tomatoes, jalapeño peppers, garlic, salt, lime juice and cilantro, pounded with a pestle and served in an authentic molcajete.",
      price: "13.99"
    }, {
      id: "cheese-dip",
      name: "Cheese Dip",
      description: "",
      prices: [{
        size: "Small",
        amount: "5.50"
      }, {
        size: "Large",
        amount: "7.99"
      }]
    }, {
      id: "loco-dip",
      name: "Loco Dip",
      description: "Cheese with ground beef or shredded chicken",
      prices: [{
        size: "Small",
        amount: "6.50"
      }, {
        size: "Large",
        amount: "8.99"
      }]
    }, {
      id: "guacamole-dip",
      name: "Guacamole Dip",
      description: "Avocado based dip mixed with onions, tomatoes, cilantro and jalapeños",
      prices: [{
        size: "Small",
        amount: "5.50"
      }, {
        size: "Large",
        amount: "7.99"
      }]
    }, {
      id: "chori-papas",
      name: "Chori Papas",
      description: "French fries topped with cheese, jalapeño and your choice of chorizo or shredded chicken.",
      price: "10.99"
    }, {
      id: "bean-dip",
      name: "Bean Dip",
      description: "Refried beans mixed with cheese dip",
      prices: [{
        size: "Small",
        amount: "6.25"
      }, {
        size: "Large",
        amount: "7.99"
      }]
    }, {
      id: "chori-queso",
      name: "Chori Queso",
      description: "Mexican pork sausage mixed with cheese dip and topped with pico de gallo.",
      price: "13.99"
    }, {
      id: "salsa",
      name: "Salsa (Regular or Mild) Carry Out Only",
      description: "",
      prices: [{
        size: "8-oz.",
        amount: "4.99"
      }, {
        size: "Large 16-oz.",
        amount: "6.99"
      }, {
        size: "X Large 32-oz.",
        amount: "13.50"
      }, {
        size: "Extra bag of chips",
        amount: "2.25 extra"
      }]
    }, {
      id: "nachos-texanos",
      name: "Nachos Texanos",
      description: "A bed of crispy tortilla chips topped with grilled sirloin steak, chicken, shrimp, green peppers, onions, tomatoes and cheese dip",
      price: "17.50"
    }, {
      id: "fajita-nachos",
      name: "Fajita Nachos",
      description: "A bed of crispy tortilla chips topped with grilled green peppers, onions, tomatoes, your choice of grilled chicken or sirloin steak and cheese dip",
      price: "15.75"
    }, {
      id: "grilled-nachos-supreme",
      name: "Grilled Nachos Supreme",
      description: "Steak, chicken or pork. Topped with cheese, lettuce, guacamole, sour cream and diced tomatoes",
      price: "17.75"
    }, {
      id: "special-nachos",
      name: "Special Nachos",
      description: "A bed of crispy tortilla chips topped with cheese dip, refried beans, ground beef or shredded chicken, lettuce, diced tomatoes, sour cream and guacamole",
      price: "14.50"
    }, {
      id: "seafood-nachos",
      name: "Seafood Nachos",
      description: "A bed of crispy tortilla chips topped with grilled shrimp, crab meat, scallops, tilapia fish, cauliflower, broccoli, carrots and cheese dip",
      price: "17.99"
    }, {
      id: "nachos-locos",
      name: "Nachos Locos",
      description: "A bed of crispy tortilla chips topped with shrimp, shredded chicken, lettuce, onions, fresh diced tomatoes, sour cream and cheese dip",
      price: "15.75"
    }, {
      id: "pulled-pork-nachos",
      name: "Pulled Pork Nachos",
      description: "Shredded pork (carnitas) topped with cheese sauce over crispy tortilla chips",
      price: "15.50"
    }, {
      id: "margaritas-nachos",
      name: "Margaritas Nachos",
      description: "A bed of crispy tortilla chips topped with your choice of:",
      prices: [{
        size: "Cheese Dip",
        amount: "8.50"
      }, {
        size: "Bean, Cheese Dip",
        amount: "9.99"
      }, {
        size: "Ground Beef, Cheese Dip",
        amount: "10.99"
      }, {
        size: "Ground Beef, Beans, Cheese Dip",
        amount: "11.99"
      }, {
        size: "Shredded Chicken, Cheese Dip",
        amount: "11.99"
      }, {
        size: "Shredded Chicken, Beans, Cheese Dip",
        amount: "12.99"
      }]
    }, {
      id: "fiesta-salads",
      name: "Fiesta Salads",
      description: "A beautiful plate of shredded lettuce with cheese, sliced avocado and diced tomatoes. Choice of one: SEAFOOD • SHRIMP • STEAK • CHICKEN",
      price: "17.50"
    }, {
      id: "fajita-taco-salad",
      name: "Fajita Taco Salad",
      description: "A deep-fried flour tortilla shell filled with refried beans, green peppers, onions and tomatoes. Topped with lettuce, sour cream, diced tomatoes, guacamole and shredded white cheese. Choice of one: SEAFOOD • SHRIMP • STEAK • CHICKEN",
      price: "17.50"
    }, {
      id: "taco-salad",
      name: "Taco Salad",
      description: "A deep-fried flour tortilla shell filled with refried beans, shredded chicken or ground beef. Topped with lettuce, sour cream, guacamole, diced tomatoes and shredded white cheese.",
      price: "15.99"
    }, {
      id: "veggie-taco-salad",
      name: "Veggie Taco Salad",
      description: "A deep-fried flour tortilla shell filled with refried beans, grilled broccoli, cauliflower and carrots. Topped with lettuce, diced tomatoes, guacamole, sour cream and shredded white cheese.",
      price: "16.50"
    }, {
      id: "king-taco-salad",
      name: "King Taco Salad",
      description: "A deep-fried flour tortilla shell with your choice of chicken, steak or pork with bacon, black beans, lettuce, rice, tomatoes, guacamole and cheese sauce.",
      price: "16.50"
    }, {
      id: "caldo-de-camaron",
      name: "Caldo de Camarón",
      description: "Mildly spicy shrimp soup made with rice, pico de gallo and avocado slices. Served with your choice of flour or corn tortillas",
      price: "18.99"
    }, {
      id: "chicken-vegetable-soup",
      name: "Chicken & Vegetable Soup",
      description: "Made with chicken, carrots, broccoli, cauliflower, rice, pico de gallo and avocado slices. Served with your choice of flour or corn tortillas",
      price: "15.75"
    }]
  }, {
    id: "entrees",
    title: "A LA Carte & Sides",
    icon: ChefHat,
    menuItems: [{
      id: "quesadillas",
      name: "Quesadillas",
      description: "Grilled flour tortilla with cheese inside",
      prices: [{
        size: "Cheese Only",
        amount: "4.75"
      }, {
        size: "Shredded Chicken",
        amount: "6.50"
      }, {
        size: "Grilled Steak",
        amount: "7.49"
      }, {
        size: "Grilled Chicken",
        amount: "7.49"
      }, {
        size: "Ground Beef",
        amount: "6.50"
      }, {
        size: "Shrimp",
        amount: "7.99"
      }, {
        size: "Mushroom",
        amount: "6.99"
      }, {
        size: "Chorizo",
        amount: "6.99"
      }]
    }, {
      id: "tacos",
      name: "Tacos",
      prices: [{
        size: "Chicken",
        amount: "3.99"
      }, {
        size: "Beef",
        amount: "3.99"
      }, {
        size: "Hard",
        amount: "3.99"
      }, {
        size: "Soft",
        amount: "3.99"
      }, {
        size: "Supreme",
        amount: "4.25"
      }, {
        size: "Extra",
        amount: "4.99"
      }]
    }, {
      id: "chile-relleno",
      name: "Chile Relleno",
      price: "5.49"
    }, {
      id: "chiles-toreados",
      name: "Chiles Toreados",
      price: "5.49"
    }, {
      id: "nacho-cheese-burrito",
      name: "Nacho Cheese Burrito",
      prices: [{
        size: "Beef or Chicken",
        amount: "7.49"
      }]
    }, {
      id: "tamales",
      name: "Tamales",
      description: "Corn based and stuffed with pork, topped with red sauce, grilled and shredded cheese",
      prices: [{
        size: "1",
        amount: "5.25"
      }]
    }, {
      id: "taco-grilled",
      name: "Taco, Grilled",
      description: "With steak, grilled chicken or carnitas",
      prices: [{
        size: "Regular",
        amount: "4.50"
      }, {
        size: "Supreme",
        amount: "5.25"
      }]
    }, {
      id: "enchiladas",
      name: "Enchiladas",
      description: "Corn tortillas topped with red sauce and shredded cheese",
      prices: [{
        size: "Cheese Only",
        amount: "4.25"
      }, {
        size: "Bean & Cheese",
        amount: "4.50"
      }, {
        size: "Ground Beef",
        amount: "5.25"
      }, {
        size: "Shredded Chicken",
        amount: "5.25"
      }]
    }, {
      id: "burritos",
      name: "Burritos",
      description: "Topped with red sauce and shredded cheese",
      prices: [{
        size: "Ground Beef",
        amount: "6.50"
      }, {
        size: "Shredded Chicken",
        amount: "6.50"
      }, {
        size: "Bean & Cheese",
        amount: "6.25"
      }, {
        size: "Bean & Chicken",
        amount: "6.50"
      }, {
        size: "Beef & Bean",
        amount: "6.99"
      }, {
        size: "Steak or Grilled Chicken",
        amount: "8.50"
      }]
    }, {
      id: "chimichangas",
      name: "Chimichangas",
      description: "Topped with cheese dip",
      prices: [{
        size: "Ground Beef",
        amount: "7.50"
      }, {
        size: "Shredded Chicken",
        amount: "7.50"
      }, {
        size: "Steak or Grilled Chicken",
        amount: "8.75"
      }]
    }, {
      id: "rice",
      name: "Rice",
      price: "3.75"
    }, {
      id: "refried-beans",
      name: "Refried Beans",
      price: "3.75"
    }, {
      id: "black-beans",
      name: "Black Beans",
      price: "3.75"
    }, {
      id: "flour-or-corn-tortillas",
      name: "Flour or Corn Tortillas",
      price: "0.99"
    }, {
      id: "french-fries",
      name: "French Fries",
      price: "2.99"
    }, {
      id: "lettuce",
      name: "Lettuce",
      price: "0.99"
    }, {
      id: "sour-cream",
      name: "Sour Cream",
      price: "0.99"
    }, {
      id: "cilantro",
      name: "Cilantro",
      price: "0.99"
    }, {
      id: "grilled-steak-side",
      name: "Grilled Steak",
      price: "5.25"
    }, {
      id: "salsa-verde",
      name: "Salsa Verde",
      price: "1.50"
    }, {
      id: "chopped-onions",
      name: "Chopped Onions",
      price: "0.99"
    }, {
      id: "grilled-onions",
      name: "Grilled Onions",
      price: "1.50"
    }, {
      id: "fresh-jalapenos",
      name: "Fresh Jalapeños",
      price: "0.99"
    }, {
      id: "shredded-cheese",
      name: "Shredded Cheese",
      price: "0.99"
    }, {
      id: "avocado-slices",
      name: "Avocado Slices",
      price: "2.99"
    }, {
      id: "diced-tomatoes",
      name: "Diced Tomatoes",
      price: "0.99"
    }, {
      id: "tomatillo-salsa",
      name: "Tomatillo Salsa",
      price: "1.50"
    }, {
      id: "jalapenos-in-vinegar",
      name: "Jalapeños in Vinegar",
      price: "0.99"
    }, {
      id: "grilled-chicken-side",
      name: "Grilled Chicken",
      price: "5.25"
    }]
  }, {
    id: "grill",
    title: "Grill Specials",
    icon: Flame,
    menuItems: [{
      id: "sizzling-fajitas-note",
      name: "Sizzling Fajitas",
      description: "All fajitas are served with lettuce, pico de gallo, guacamole, rice or beans and your choice of corn or flour tortillas"
    }, {
      id: "fajitas",
      name: "Fajitas",
      description: "Your choice of grilled sirloin or chicken fajitas, green peppers, onions and tomatoes",
      prices: [{
        size: "Chicken",
        amount: "17.99"
      }, {
        size: "Steak",
        amount: "19.50"
      }]
    }, {
      id: "seafood-fajitas",
      name: "Seafood Fajitas",
      description: "Grilled shrimp, crab meat, tilapia fish, broccoli, cauliflower and carrots",
      price: "19.95"
    }, {
      id: "hawaiian-fajitas",
      name: "Hawaiian Fajitas",
      description: "Delicious grilled steak or chicken cooked with onions, tomatoes, bell peppers, fresh pineapple and bits of crispy bacon",
      price: "22.50"
    }, {
      id: "mixed-fajitas",
      name: "Mixed Fajitas",
      description: "Grilled sirloin steak, chicken, green peppers, onions and tomatoes",
      price: "21.50"
    }, {
      id: "fajitas-fundida",
      name: "Fajitas Fundida",
      description: "Steak, chicken, shrimp and chorizo cooked with bell peppers, onions and tomatoes, served with cheese dip and pineapple slices. Served with a salad",
      price: "24.50"
    }, {
      id: "shrimp-fajitas",
      name: "Shrimp Fajitas",
      description: "Grilled shrimp, green peppers, onions and tomatoes",
      price: "21.99"
    }, {
      id: "texas-fajitas",
      name: "Texas Fajitas",
      description: "Grilled sirloin steak, chicken, shrimp, green peppers, onions and tomatoes",
      price: "22.75"
    }, {
      id: "veggie-fajitas",
      name: "Veggie Fajitas",
      description: "Fresh grilled vegetables including bell peppers, onions, tomatoes, broccoli, carrots and cauliflower. Served with rice or beans, tortillas and salad",
      price: "18.50"
    }, {
      id: "tortas",
      name: "Tortas",
      description: "A Mexican sandwich with beans, mayo, avocado, jalapeños, onions, lettuce and cheese. Choices: Steak • Chorizo • Pastor • Chicken • Cubana",
      price: "16.50"
    }, {
      id: "tacos",
      name: "Tacos",
      description: "Three tacos served with cilantro, onions, corn tortillas, rice and beans",
      prices: [{
        size: "Fish Tacos",
        amount: "16.75"
      }, {
        size: "Tacos de Carne Asada",
        amount: "16.75"
      }, {
        size: "Tacos de Carnitas",
        amount: "16.75"
      }, {
        size: "Shrimp Tacos",
        amount: "16.75"
      }, {
        size: "Tacos al Pastor",
        amount: "16.75"
      }, {
        size: "Tacos Campechanos",
        amount: "16.75"
      }, {
        size: "Tacos de Chorizo",
        amount: "16.75"
      }, {
        size: "Tacos de Birria",
        amount: "16.75"
      }]
    }]
  }, {
    id: "burritos-quesadillas",
    title: "Burritos, Quesadillas, Enchiladas, & Chimichangas",
    icon: UtensilsCrossed,
    menuItems: [
    // =========================
    // BURRITOS
    // =========================
    {
      id: "super-amigos",
      name: "1. Super Amigos",
      description: "Three burritos — one with grilled chicken, one with grilled steak and one with carnitas (pork) — topped with cheese, green tomatillo sauce and sour cream",
      price: "18.75"
    }, {
      id: "monterrey-burrito",
      name: "2. Monterrey Burrito",
      description: "Filled with grilled chicken, onions and rice with our special spicy seasoning. Topped with cheese",
      price: "16.99"
    }, {
      id: "burrito-texas-special",
      name: "3. Burrito Texas Special",
      description: "A big flour tortilla stuffed with grilled shrimp, sirloin steak, chicken, green peppers, onions, tomatoes and beans inside. Topped with cheese dip and salsa verde, served with rice",
      price: "17.50"
    }, {
      id: "veggie-burrito",
      name: "4. Veggie Burrito",
      description: "A large flour tortilla stuffed with grilled broccoli, cauliflower, mushrooms, carrots and beans inside. Topped with cheese dip and salsa verde. Served with rice, guacamole salad and pico de gallo",
      price: "16.75"
    }, {
      id: "burrito-chile-colorado",
      name: "5. Burrito Chile Colorado",
      description: "A big flour tortilla filled with steak cooked in a red sauce. Topped with cheese dip and red sauce, served with rice",
      price: "16.99"
    }, {
      id: "king-burrito",
      name: "6. King Burrito",
      description: "A large tortilla filled with your choice of chicken, steak or pork with bacon, black beans, rice, guacamole and cheese sauce",
      price: "16.99"
    }, {
      id: "burrito-de-carne-asada",
      name: "7. Burrito de Carne Asada",
      description: "A big flour tortilla filled with grilled sirloin steak, beans and onions. Topped with cheese dip and salsa verde, served with rice",
      price: "17.75"
    }, {
      id: "burrito-loco-fajita",
      name: "8. Burrito Loco Fajita",
      description: "A large flour tortilla stuffed with grilled chicken or steak, green peppers, lettuce, onions and tomatoes. Topped with cheese dip and pico de gallo",
      price: "16.99"
    }, {
      id: "burrito-deluxe",
      name: "9. Burrito Deluxe",
      description: "Large tortilla with your choice of shredded chicken, shredded beef or ground beef, filled with lettuce, tomato, sour cream, rice and beans. Deep fried and topped with cheese sauce",
      price: "16.25"
    }, {
      id: "burrito-toluca",
      name: "10. Burrito Toluca",
      description: "A big flour tortilla stuffed with grilled sirloin steak, chorizo, pork, green peppers, onions, tomatoes and beans inside. Topped with cheese dip, lettuce, avocado slices and diced tomatoes",
      price: "17.50"
    }, {
      id: "burrito-acapulco",
      name: "11. Burrito Acapulco",
      description: "A big flour tortilla filled with grilled pork, green peppers, beans, onions and tomatoes. Served with lettuce, guacamole, diced tomatoes, sour cream and white cheese sauce",
      price: "17.50"
    }, {
      id: "burritos-mexicanos",
      name: "12. Burritos Mexicanos",
      description: "Two burritos — one shredded chicken and one ground beef with beans inside. Both topped with salsa ranchera, guacamole, lettuce, diced tomatoes and sour cream",
      price: "16.99"
    }, {
      id: "add-cheese-sauce",
      name: "Add Cheese Sauce",
      price: "1.50"
    }, {
      id: "burrito-al-pastor",
      name: "13. Burrito al Pastor",
      description: "A large tortilla filled with our pastor pork covered with ranchero sauce and shredded cheese. Served with rice, black beans, lettuce, tomatoes and sour cream",
      price: "16.99"
    }, {
      id: "burrito-bowl",
      name: "14. Burrito Bowl",
      description: "Rice, black beans, lettuce, shredded cheese, avocado, tomato, corn and your choice of meat",
      price: "16.99"
    }, {
      id: "wet-burrito",
      name: "15. Wet Burrito",
      description: "A tortilla stuffed with grilled chicken and shrimp with rice inside, smothered in queso dip",
      price: "16.99"
    }, {
      id: "burrito-ranchero",
      name: "16. Burrito Ranchero",
      description: "Grilled steak or chicken with chorizo, mushroom, onion and tomato. Topped with cheese and sour cream. Served with rice",
      price: "16.99"
    }, {
      id: "burrito-de-camaron",
      name: "17. Burrito de Camarón",
      description: "A large tortilla filled with 10 shrimp, tomatoes, peppers and onions. Covered with cheese sauce, lettuce, tomatoes and sour cream",
      price: "17.25"
    }, {
      id: "three-amigos-burritos",
      name: "18. Three Amigos",
      description: "Three burritos — one shredded chicken, one ground beef and one beef tips — all topped with cheese sauce and red sauce",
      price: "16.99"
    },
    // =========================
    // QUESADILLAS
    // =========================
    {
      id: "quesadilla-suprema",
      name: "Quesadilla Suprema",
      description: "A large flour tortilla grilled with melted cheese, shrimp, chicken, sirloin steak, green peppers, onions and tomatoes. Served with lettuce, diced tomatoes, sour cream and rice",
      price: "18.50"
    }, {
      id: "quesadilla-favorita",
      name: "Quesadilla Favorita",
      description: "Filled with grilled chicken and chorizo (Mexican sausage), topped with cheese dip. Served with rice, lettuce, diced tomatoes and sour cream",
      price: "17.75"
    }, {
      id: "big-fajita-quesadilla",
      name: "Big Fajita Quesadilla",
      description: "A flour tortilla grilled with melted cheese, choice of meat: steak, chicken or shrimp, green peppers, onions and tomatoes. Served with lettuce, guacamole, diced tomatoes and rice",
      price: "17.50"
    }, {
      id: "quesadilla-al-pastor",
      name: "Quesadilla al Pastor",
      description: "Filled with pork cooked in our spicy sauce. Served with rice, beans, sour cream, lettuce and diced tomato",
      price: "17.75"
    }, {
      id: "quesadilla-mexicana",
      name: "Quesadilla Mexicana",
      description: "A flour tortilla grilled with melted cheese, shredded beef, shredded chicken or ground beef. Served with lettuce, sour cream, guacamole, diced tomatoes and your choice of rice or beans",
      price: "16.25"
    }, {
      id: "mushroom-quesadilla",
      name: "Mushroom Quesadilla",
      description: "With mushrooms, onions, tomatoes and bell peppers. Served with rice, lettuce, diced tomatoes and sour cream",
      price: "17.50"
    }, {
      id: "veggie-fajita-quesadilla",
      name: "Veggie Fajita Quesadilla",
      description: "Green bell peppers, onions, tomatoes, cauliflower, mushrooms, carrots and broccoli. Served with rice, lettuce, diced tomatoes and sour cream",
      price: "17.50"
    }, {
      id: "birria-quesadilla",
      name: "Birria Quesadilla",
      description: "Two filled quesadillas filled with melted cheese and birria. Served with rice and beans",
      price: "18.75"
    }, {
      id: "fajita-quesadilla-with-mushrooms",
      name: "Fajita Quesadilla with Mushrooms",
      description: "Two filled quesadillas filled with melted cheese and your choice of marinated chicken or ribeye steak with mushrooms, onions, tomatoes and peppers. Served with rice and beans",
      price: "18.75"
    }, {
      id: "shrimp-mushroom-quesadilla",
      name: "Shrimp & Mushroom Quesadilla",
      description: "A large flour tortilla filled with melted cheese and juicy shrimp grilled with mushrooms, carrots, broccoli and cauliflower. Served with rice, lettuce and pico de gallo",
      price: "18.99"
    },
    // =========================
    // ENCHILADAS (existing)
    // =========================
    {
      id: "enchiladas-rancheras",
      name: "Enchiladas Rancheras",
      description: "Four tortillas: one shredded chicken, one bean, one cheese and one ground beef. Topped with red ranchero sauce, shredded white cheese, lettuce, sour cream and diced tomatoes",
      price: "17.50"
    }, {
      id: "veggie-enchiladas",
      name: "Veggie Enchiladas",
      description: "Three corn tortillas stuffed with grilled cauliflower, broccoli and carrots. Topped with cheese dip and salsa verde, served with lettuce, diced tomatoes, guacamole, sour cream and rice",
      price: "16.99"
    }, {
      id: "yucatan-enchiladas",
      name: "Yucatan Enchiladas",
      description: "Two corn tortillas stuffed with shredded chicken or shredded beef, topped with cheese dip and sour cream. Served with beans, lettuce and diced tomatoes",
      price: "15.99"
    }, {
      id: "enchiladas-verdes",
      name: "Enchiladas Verdes",
      description: "Four corn tortillas stuffed with grilled chicken, topped with cheese dip, salsa verde and sour cream. Served with rice",
      price: "16.99"
    }, {
      id: "enchiladas-mexicanas",
      name: "Enchiladas Mexicanas",
      description: "Three corn tortillas stuffed with beef tips, topped with red sauce and shredded white cheese. Served with rice and beans",
      price: "15.99"
    }, {
      id: "enchiladas-superior",
      name: "Enchiladas Superior",
      description: "Three cheese enchiladas topped with carnitas, cheese sauce and salsa verde. Served with rice or beans and guacamole salad",
      price: "16.99"
    }, {
      id: "enchiladas-suizas",
      name: "Enchiladas Suizas",
      description: "Three cheese enchiladas topped with red mole sauce, shredded cheese, two eggs and bacon. Served with rice",
      price: "16.99"
    },
    // =========================
    // CHIMICHANGAS
    // =========================
    {
      id: "texas-chimichanga",
      name: "1. Texas Chimichanga",
      description: "A large flour tortilla deep-fried, stuffed with grilled shrimp, sirloin steak, chicken, green peppers, onions and tomatoes. Topped with cheese dip and served with lettuce, pico de gallo, guacamole, sour cream and rice",
      price: "17.75"
    }, {
      id: "chimichanga-margaritas",
      name: "2. Chimichanga Margaritas",
      description: "A deep-fried flour tortilla stuffed with grilled sirloin steak or chicken, green peppers, onions and tomatoes. Topped with cheese dip and served with lettuce, guacamole, diced tomatoes, sour cream and rice",
      price: "16.99"
    }, {
      id: "veggie-chimichanga",
      name: "3. Veggie Chimichanga",
      description: "A flour tortilla wrapped around sautéed fresh garden vegetables including cauliflower, broccoli and carrots. Served with rice, lettuce, sour cream and tomato",
      price: "16.75"
    }, {
      id: "chimichangas-mexicana",
      name: "4. Chimichangas Mexicana",
      description: "Two deep-fried flour tortillas stuffed with shredded chicken, shredded beef or ground beef. Topped with cheese dip and served with lettuce, guacamole, pico de gallo and rice",
      price: "15.99"
    }, {
      id: "chicken-bacon-chimichanga",
      name: "5. Chicken Bacon Chimichanga",
      description: "Filled with grilled chicken and bacon. Served with lettuce, sour cream, tomato and rice",
      price: "16.99"
    }, {
      id: "shrimp-chimichanga",
      name: "6. Shrimp Chimichanga",
      description: "A deep-fried flour tortilla stuffed with grilled shrimp, onions, green peppers and tomatoes, topped with cheese dip. Served with lettuce, guacamole, pico de gallo and rice",
      price: "17.75"
    }]
  }, {
    id: "specials",
    title: "Specials",
    icon: Star,
    menuItems: [
    // =========================
    // ARROZ SPECIALS
    // =========================
    {
      id: "arroz-specials",
      name: "Arroz Specials",
      description: "Grilled chicken strips served atop a bed of rice covered in cheese dip. Served with lettuce, pico de gallo, guacamole and your choice of corn or flour tortillas"
    }, {
      id: "arroz-con-pollo",
      name: "Arroz con Pollo",
      prices: [{
        size: "Chicken",
        amount: "16.50"
      }, {
        size: "Steak",
        amount: "16.99"
      }, {
        size: "Shrimp",
        amount: "18.99"
      }]
    }, {
      id: "arroz-texano",
      name: "Arroz Texano",
      description: "Steak, chicken, shrimp over a bed of rice covered in cheese sauce",
      price: "18.99"
    }, {
      id: "arroz-monterrey-special",
      name: "Arroz Monterrey Special",
      description: "Steak or chicken with chorizo and 5 shrimp over a bed of rice covered with cheese sauce",
      price: "18.99"
    }, {
      id: "arroz-con-camarones-y-vegetables",
      name: "Arroz con Camarones y Vegetables",
      description: "Grilled shrimp, broccoli, cauliflower and carrots. Served atop a bed of rice. Served with lettuce, avocado slices, sour cream, pico de gallo and your choice of corn or flour tortillas",
      price: "19.99"
    },
    // =========================
    // CREATE YOUR OWN COMBO
    // =========================
    {
      id: "create-your-own-combo",
      name: "Create Your Own Combo",
      description: "Served with rice and beans. Choice of meat: ground beef • shredded beef • shredded chicken (ask server for grilled choices). Choose from: taco • tamale • enchilada • quesadilla • burrito • chile relleno"
    }, {
      id: "combo-pick-one",
      name: "Pick One",
      price: "13.99"
    }, {
      id: "combo-pick-two",
      name: "Pick Two",
      price: "15.99"
    }, {
      id: "combo-pick-three",
      name: "Pick Three",
      price: "17.99"
    },
    // =========================
    // TEXAS MARGARITAS SPECIALS
    // =========================
    {
      id: "texas-margaritas-specials",
      name: "Texas Margaritas Specials"
    }, {
      id: "acapulco-special",
      name: "Acapulco Special",
      description: "Grilled chicken fajitas, green peppers and onions cooked in a special creamy sauce. Served with lettuce, guacamole, diced tomatoes, rice and your choice of corn or flour tortillas",
      price: "17.99"
    }, {
      id: "pollo-favorito",
      name: "Pollo Favorito",
      description: "A grilled chicken breast topped with grilled green peppers, onions, tomatoes and cheese dip. Served with lettuce, guacamole, diced tomatoes, rice and your choice of corn or flour tortillas",
      price: "17.75"
    }, {
      id: "pollo-fundido",
      name: "Pollo Fundido",
      description: "Two deep-fried flour tortillas stuffed with shredded chicken. Topped with cheese dip and sour cream. Served with lettuce, guacamole, diced tomatoes and choice of rice or beans",
      price: "16.50"
    }, {
      id: "pollo-chipotle",
      name: "Pollo Chipotle",
      description: "Marinated chicken breast strips cooked with our special chipotle sauce. Served with rice, beans and tortillas",
      price: "16.50"
    }, {
      id: "add-mushrooms",
      name: "Add mushrooms",
      price: "1.99"
    }, {
      id: "pollo-loco",
      name: "Pollo Loco",
      description: "Grilled chicken cooked with jalapeños, chorizo, mushrooms and our delicious white cheese sauce. Served with rice and beans",
      price: "16.99"
    }, {
      id: "chicken-and-mushrooms",
      name: "Chicken & Mushrooms",
      description: "Tender chicken strips grilled with mushrooms, bell peppers, onions and tomatoes. Topped with cheese and served with rice, lettuce, pico de gallo and choice of corn or flour tortillas",
      price: "17.49"
    }, {
      id: "chori-pollo",
      name: "Chori Pollo",
      description: "Chicken strips and chorizo over a bed of rice, covered with cheese",
      price: "16.99"
    }, {
      id: "pollo-asado",
      name: "Pollo Asado",
      description: "Grilled chicken topped with grilled onions. Served with lettuce, guacamole, diced tomatoes, sour cream and rice",
      price: "16.99"
    }, {
      id: "carnitas-en-salsa",
      name: "Carnitas en Salsa",
      description: "Tender, juicy pork chunks lightly fried and marinated in your choice of salsa verde or salsa roja. Served with lettuce, guacamole, diced tomatoes, rice, beans and your choice of corn or flour tortillas",
      price: "19.50"
    }, {
      id: "monterrey-carnitas",
      name: "Monterrey Carnitas",
      description: "Tender pork chunks lightly fried. Served with rice, beans and your choice of corn or flour tortillas",
      price: "17.75"
    }, {
      id: "chile-colorado-or-verde",
      name: "Chile Colorado or Verde",
      description: "Lightly fried beef chunks mixed in a red spicy sauce. Served with lettuce, guacamole, diced tomatoes, rice, beans and your choice of corn or flour tortillas",
      price: "16.99"
    }, {
      id: "taquitos-mexicanos",
      name: "Taquitos Mexicanos",
      description: "Four deep-fried flautas — two stuffed with shredded beef and two stuffed with shredded chicken. Served with guacamole, sour cream and pico de gallo",
      price: "16.50"
    }, {
      id: "pollo-toluca",
      name: "Pollo Toluca",
      description: "A grilled chicken breast topped with chorizo and cheese. Served with rice, beans and tortillas",
      price: "17.99"
    }]
  }, {
    id: "seafood",
    title: "Seafood and Vegetarian",
    icon: Fish,
    menuItems: [
    // =========================
    // SEAFOOD
    // =========================
    {
      id: "seafood-cocktail-de-camarones",
      name: "Seafood Cocktail de Camarones",
      description: "A cold glass filled with shrimp, avocado slices, cilantro, pico de gallo and cocktail sauce. Served with limes and crackers",
      price: "19.50"
    }, {
      id: "camarones-al-mojo",
      name: "Camarones al Mojo",
      description: "Grilled shrimp marinated in garlic, cooked with onions. Served with lettuce, guacamole, pico de gallo, rice and your choice of corn or flour tortillas",
      price: "18.99"
    }, {
      id: "camarones-a-la-diabla",
      name: "Camarones a la Diabla",
      description: "Grilled shrimp marinated in spicy diabla sauce cooked with onions. Served with lettuce, guacamole, pico de gallo, rice, beans and your choice of corn or flour tortillas",
      price: "19.50"
    }, {
      id: "camarones-chipotle",
      name: "Camarones Chipotle",
      description: "Grilled shrimp marinated in spicy chipotle sauce cooked with onions. Served with lettuce, guacamole, pico de gallo, rice and your choice of corn or flour tortillas",
      price: "19.99"
    }, {
      id: "add-mushrooms-seafood",
      name: "Add Mushrooms",
      price: "1.99"
    }, {
      id: "seafood-enchiladas-del-golfo",
      name: "Seafood Enchiladas del Golfo",
      description: "Two flour tortillas stuffed with grilled shrimp, crab meat, broccoli, cauliflower and carrots. Topped with cheese dip, salsa verde and sour cream. Served with rice, lettuce, guacamole and diced tomatoes",
      price: "18.50"
    }, {
      id: "seafood-quesadilla",
      name: "Seafood Quesadilla",
      description: "A flour tortilla grilled with melted cheese, shrimp, crab meat, broccoli, cauliflower and carrots. Served with rice, lettuce, guacamole, diced tomatoes and sour cream",
      price: "18.50"
    }, {
      id: "seafood-chimichanga",
      name: "Seafood Chimichanga",
      description: "A deep-fried flour tortilla stuffed with grilled shrimp, crab meat, broccoli, cauliflower and carrots, topped with cheese dip. Served with rice, lettuce, guacamole, pico de gallo and sour cream",
      price: "17.99"
    }, {
      id: "burrito-del-golfo",
      name: "Burrito del Golfo",
      description: "A large tortilla stuffed with grilled shrimp, crab meat, broccoli, cauliflower and carrots. Topped with cheese dip and salsa verde. Served with lettuce, pico de gallo, rice and beans",
      price: "17.99"
    }, {
      id: "shrimp-and-mushrooms",
      name: "Shrimp & Mushrooms",
      description: "Juicy shrimp grilled with mushrooms, broccoli, cauliflower and carrots. Topped with cheese and served with rice, lettuce, pico de gallo and your choice of corn or flour tortillas",
      price: "17.99"
    },
    // =========================
    // VEGETARIAN
    // =========================
    {
      id: "vegetarian-combo",
      name: "Vegetarian Combo",
      description: "All burritos and enchiladas are topped with red sauce",
      price: "17.99"
    }, {
      id: "veg-option-1",
      name: "1. One Bean Burrito & One Cheese Enchilada",
      description: "With beans or rice"
    }, {
      id: "veg-option-2",
      name: "2. Two Cheese Enchiladas",
      description: "With rice & beans"
    }, {
      id: "veg-option-3",
      name: "3. One Bean & Cheese Burrito, Bean Enchilada & Cheese Quesadilla"
    }, {
      id: "veg-option-4",
      name: "4. Two Bean Burritos",
      description: "With rice"
    }, {
      id: "veg-option-5",
      name: "5. One Burrito, One Quesadilla & Guacamole Salad"
    }, {
      id: "veg-option-6",
      name: "6. One Chile Relleno",
      description: "With rice or beans and a guacamole salad"
    }]
  }, {
    id: "lunch-specials",
    title: "Lunch Specials",
    icon: Star,
    menuItems: [{
      id: "lunch-info",
      name: "Lunch at Texas Margaritas",
      description: "Served between 11:00 A.M. – 3:00 P.M. Monday through Friday only. All combinations are made with ground beef but can be changed to shredded chicken. Add cheese dip to any burrito or enchilada – 1.00 per person. Substitute rib-eye steak or grilled chicken in burritos – 2.50 extra or enchiladas – 2.00 extra."
    }, {
      id: "lunch-1",
      name: "1. Speedy Gonzales",
      description: "One hard ground beef taco, one beef enchilada with rice or beans",
      price: "10.99"
    }, {
      id: "lunch-2",
      name: "2. Lunch Special",
      description: "One hard ground beef taco, one chile relleno, rice or beans",
      price: "11.50"
    }, {
      id: "lunch-3",
      name: "3. Lunch Special",
      description: "One beef burrito, rice and beans",
      price: "10.50"
    }, {
      id: "lunch-4",
      name: "4. Lunch Special",
      description: "Two beef enchiladas, rice or beans",
      price: "10.99"
    }, {
      id: "lunch-5",
      name: "5. Lunch Special",
      description: "Two beef tacos with rice or beans",
      price: "10.99"
    }, {
      id: "lunch-6",
      name: "6. Lunch Special",
      description: "One hard ground beef taco, one beef burrito, rice or beans",
      price: "11.50"
    }, {
      id: "lunch-7",
      name: "7. Lunch Special",
      description: "One beef enchilada, one pork tamale, rice or beans",
      price: "12.50"
    }, {
      id: "lunch-8",
      name: "8. Lunch Special",
      description: "One beef burrito, one beef enchilada, rice or beans",
      price: "12.99"
    }, {
      id: "lunch-9",
      name: "9. Lunch Special",
      description: "A quesadilla stuffed with ground beef or shredded chicken. Served with rice and beans",
      price: "10.99"
    }, {
      id: "lunch-10",
      name: "10. Arroz con Pollo",
      description: "Grilled chicken strips served atop a bed of rice covered in cheese dip. Served with lettuce, guacamole, pico de gallo and your choice of corn or flour tortillas",
      price: "12.50"
    }, {
      id: "lunch-11",
      name: "11. Lunch Fajita Quesadilla",
      description: "Flour tortilla stuffed with grilled rib-eye steak or chicken, green peppers, onions and tomatoes. Served with lettuce, guacamole and rice",
      price: "13.50"
    }, {
      id: "lunch-12",
      name: "12. Lunch Quesadilla Suprema",
      description: "Flour tortilla stuffed with grilled sirloin steak, chicken, shrimp, green peppers, onions and tomatoes. Served with lettuce, guacamole and rice",
      price: "14.50"
    }, {
      id: "lunch-13",
      name: "13. Shrimp Tacos",
      description: "Two grilled soft shrimp tacos served with lettuce, cheese, rice and beans",
      price: "14.50"
    }, {
      id: "lunch-14",
      name: "14. Lunch Burrito Supremo",
      description: "Flour tortilla stuffed with ground beef or shredded chicken and beans. Topped with red supreme sauce, lettuce, diced tomatoes and sour cream",
      price: "11.99"
    }, {
      id: "lunch-15",
      name: "15. Lunch Burrito Loco",
      description: "Flour tortilla stuffed with grilled sirloin steak or chicken, green peppers, onions, lettuce and tomatoes inside. Topped with cheese dip and pico de gallo",
      price: "12.99"
    }, {
      id: "lunch-16",
      name: "16. Lunch Chicken Chimichanga",
      description: "One flour tortilla deep-fried and stuffed with ground beef, shredded beef or shredded chicken. Topped with cheese dip and served with lettuce, guacamole, diced tomatoes and rice",
      price: "11.99"
    }, {
      id: "lunch-17",
      name: "17. Lunch Texas Chimichanga",
      description: "Flour tortilla deep-fried and stuffed with grilled rib-eye steak, chicken, shrimp, green peppers, onions and tomatoes. Served with lettuce, diced tomatoes and sour cream",
      price: "13.75"
    }, {
      id: "lunch-18",
      name: "18. Pollo Loco",
      description: "Grilled chicken cooked with chorizo, jalapeños and mushrooms in our delicious white cheese sauce. Served with rice and beans",
      price: "13.99"
    }, {
      id: "lunch-19",
      name: "19. Huevos con Chorizo",
      description: "Two eggs scrambled with Mexican sausage, served with rice, beans and your choice of corn or flour tortillas",
      price: "12.99"
    }, {
      id: "lunch-20",
      name: "20. Huevos Rancheros",
      description: "Two over easy eggs topped with ranchero sauce, served with rice, beans and your choice of corn or flour tortillas",
      price: "11.99"
    }, {
      id: "lunch-21",
      name: "21. Lunch Fajitas",
      description: "Grilled rib-eye steak or chicken, green peppers, onions and tomatoes. Served with lettuce, guacamole and your choice of corn or flour tortillas",
      price: "13.99"
    }, {
      id: "lunch-22",
      name: "22. Lunch Texas Fajitas",
      description: "Grilled rib-eye steak, chicken, shrimp, green peppers, onions and tomatoes. Served with lettuce, guacamole and your choice of corn or flour tortillas",
      price: "14.50"
    }, {
      id: "lunch-23",
      name: "23. Lunch Dos Amigos",
      description: "Two burritos — one shredded chicken and one ground beef — both topped with cheese dip and sour cream",
      price: "12.99"
    }, {
      id: "lunch-24",
      name: "24. Lunch Enchiladas Rancheras",
      description: "Three enchiladas — one shredded chicken, one ground beef and one cheese. Topped with red ranchero sauce, lettuce, diced tomatoes and sour cream",
      price: "12.50"
    }, {
      id: "lunch-25",
      name: "25. Veggie Fajitas",
      description: "Fresh grilled vegetables including bell peppers, onions, tomatoes, broccoli, carrots and cauliflower. Served with rice or beans and salad",
      price: "14.99"
    }, {
      id: "lunch-26",
      name: "26. Lunch Enchiladas Verde",
      description: "Three enchiladas stuffed with grilled chicken, topped with cheese dip, salsa verde and sour cream. Served with rice",
      price: "12.75"
    }, {
      id: "lunch-27",
      name: "27. Lunch Shrimp Fajitas",
      price: "14.99"
    }, {
      id: "lunch-28",
      name: "28. Pollo Chipotle",
      description: "Marinated chicken breast strips cooked with our special chipotle sauce. Served with rice, beans and tortillas",
      price: "12.99"
    }, {
      id: "lunch-29",
      name: "29. Mushroom Quesadilla",
      description: "With mushrooms, onions, tomatoes and bell peppers. Served with rice, lettuce, tomatoes and sour cream",
      price: "13.50"
    }, {
      id: "lunch-30",
      name: "30. Enchiladas Superior",
      description: "Two cheese enchiladas topped with carnitas, cheese sauce and salsa verde. Served with rice",
      price: "13.99"
    }, {
      id: "lunch-31",
      name: "31. Enchiladas Suizas",
      description: "Two cheese enchiladas topped with red mole sauce, shredded cheese, two eggs and bacon. Served with rice",
      price: "13.99"
    }, {
      id: "lunch-32",
      name: "32. Lunch Pollo Fundido",
      description: "One deep-fried burrito stuffed with shredded chicken. Topped with cheese dip and sour cream. Served with lettuce, guacamole, diced tomatoes and rice or beans",
      price: "12.50"
    }]
  }, {
    id: "kids",
    title: "Little Amigos Menu (Kids Menu)",
    icon: Coffee,
    menuItems: [{
      id: "kids-intro",
      name: "YOUR CHOICE",
      description: "For children 12 years or younger. Served with a soft drink. All burritos and enchiladas are topped with red sauce.",
      price: "8.99"
    }, {
      id: "amigo-burger",
      name: "AMIGO BURGER",
      description: "Includes lettuce, tomato and cheese dip. Served with French fries",
      price: "8.99"
    }, {
      id: "chicken-nuggets",
      name: "CHICKEN NUGGETS",
      description: "Served with French fries",
      price: "8.99"
    }, {
      id: "kids-combo",
      name: "KIDS COMBO",
      description: "Your choice of one: TACO • ENCHILADA • BURRITO • QUESADILLA SHREDDED CHICKEN OR GROUND BEEF QUESADILLA. Served with rice and beans",
      price: "8.99"
    }, {
      id: "mac-and-cheese",
      name: "MAC & CHEESE",
      description: "",
      price: "8.99"
    }, {
      id: "little-arroz",
      name: "LITTLE ARROZ",
      description: "With chicken, steak or shrimp",
      price: "8.99"
    }]
  }, {
    id: "drinks",
    title: "Beverages & Margaritas",
    icon: Wine,
    menuItems: [{
      id: "soft-drinks",
      name: "Soft Drinks",
      description: "We proudly serve Coke Products - No free refills",
      price: "3.49"
    }, {
      id: "iced-tea",
      name: "Iced Tea",
      description: "Free refills Sweetened or Unsweetened",
      price: "3.49"
    }, {
      id: "agua-de-horchata",
      name: "Agua de Horchata",
      description: "No free refills",
      price: "6.50"
    }, {
      id: "chocolate-milk",
      name: "Chocolate Milk",
      description: "No free refills",
      price: "2.29"
    }, {
      id: "orange-juice",
      name: "Orange Juice",
      description: "No free refills",
      price: "3.50"
    }, {
      id: "milk",
      name: "Milk",
      description: "No free refills",
      price: "2.50"
    }, {
      id: "patron-silver-margarita",
      name: "Patrón Silver Margarita",
      description: "Served on the rocks",
      prices: [{
        size: "20-oz. Medium",
        amount: "14.50"
      }, {
        size: "28-oz. Jumbo",
        amount: "17.99"
      }, {
        size: "38-oz. Monster",
        amount: "28.99"
      }, {
        size: "60-oz. Pitcher",
        amount: "34.99"
      }]
    }, {
      id: "flavored-margaritas",
      name: "Flavored Margaritas",
      description: "Made with Gold tequila. Served frozen. Flavors: PEACH • RASPBERRY • STRAWBERRY • MANGO",
      prices: [{
        size: "20-oz. Medium",
        amount: "14.50"
      }, {
        size: "28-oz. Jumbo",
        amount: "17.50"
      }, {
        size: "38-oz. Monster",
        amount: "26.50"
      }, {
        size: "60-oz. Pitcher",
        amount: "32.50"
      }]
    }, {
      id: "jumbo-blue-margarita",
      name: "Jumbo Blue Margarita",
      description: "Enjoy the good flavor made with lime juice, triple C, sweet & sour, blue curacao and Gold tequila",
      price: "18.99"
    }, {
      id: "jumbo-tropical-margarita",
      name: "Jumbo Tropical Margarita",
      description: "28-oz. Made with lime flavor, pineapple juice, piña colada, mango, sweet & sour with grenadine and Jose Cuervo Silver Tequila",
      price: "18.99"
    }, {
      id: "texas-margarita",
      name: "Texas Margarita",
      description: "Made with a double shot of Gold tequila and one shot each of Grand Marnier and triple sec with sweet & sour and authentic lime flavor. Served on the rocks",
      prices: [{
        size: "20-oz. Medium",
        amount: "14.50"
      }, {
        size: "28-oz. Jumbo",
        amount: "17.25"
      }, {
        size: "38-oz. Monster",
        amount: "27.50"
      }, {
        size: "60-oz. Pitcher",
        amount: "34.99"
      }]
    }, {
      id: "golden-house-margarita",
      name: "Golden House Margarita",
      description: "Made with Gold tequila, lime flavor, sweet & sour and triple sec. Served with a salted rim and garnished with a wedge of lime. Frozen or on the rocks",
      prices: [{
        size: "20-oz. Medium",
        amount: "13.50"
      }, {
        size: "28-oz. Jumbo",
        amount: "16.99"
      }, {
        size: "38-oz. Monster",
        amount: "25.99"
      }, {
        size: "60-oz. Pitcher",
        amount: "32.99"
      }]
    }, {
      id: "margacoronita",
      name: "Margacoronita",
      description: "28-oz. Jumbo Only",
      price: "19.99"
    }, {
      id: "hurricane",
      name: "Hurricane",
      description: "Orange juice, pineapple juice and rum",
      price: "14.99"
    }, {
      id: "skinny-margarita",
      name: "Skinny Margarita",
      description: "Jumbo",
      price: "17.99"
    }]
  }, {
    id: "beer-tequila",
    title: "Tequila, Beer, & More!",
    icon: Wine,
    menuItems: [{
      id: "imported-draft",
      name: "Imported Draft",
      description: "Ask server for availability",
      prices: [{
        size: "16-oz. Glass",
        amount: "5.75"
      }, {
        size: "23-oz. Glass",
        amount: "6.75"
      }, {
        size: "32-oz. Glass",
        amount: "7.75"
      }, {
        size: "60-oz. Pitcher",
        amount: "11.75"
      }]
    }, {
      id: "imported-bottles",
      name: "Imported Bottles",
      description: "DOS EQUIS DARK • DOS EQUIS LAGER • CORONA • NEGRA MODELO • MODELO ESPECIAL • VICTORIA",
      price: "5.25"
    }, {
      id: "domestic-draft",
      name: "Domestic Draft",
      description: "Ask server for availability",
      prices: [{
        size: "16-oz. Glass",
        amount: "4.50"
      }, {
        size: "23-oz. Glass",
        amount: "6.25"
      }, {
        size: "32-oz. Glass",
        amount: "7.25"
      }, {
        size: "60-oz. Pitcher",
        amount: "10.25"
      }]
    }, {
      id: "domestic-bottles",
      name: "Domestic Bottles",
      description: "BUDWEISER • BUD LIGHT • COORS LIGHT • MILLER LITE • MICHELOB ULTRA",
      price: "4.75"
    }, {
      id: "long-island-iced-tea",
      name: "Long Island Iced Tea",
      description: "",
      price: "16.99"
    }, {
      id: "pina-colada",
      name: "Piña Colada",
      description: "",
      price: "14.50"
    }, {
      id: "daiquiri",
      name: "Daiquiri",
      description: "Enjoy your favorite! Strawberry, peach, raspberry or mango 13½-oz.",
      price: "13.50"
    }, {
      id: "michelada",
      name: "Michelada",
      description: "Your choice of beer with tomato juice and lime with a salted rim",
      price: "17.99"
    }, {
      id: "tequila-sunrise",
      name: "Tequila Sunrise",
      description: "",
      price: "14.50"
    }, {
      id: "tequila-shots",
      name: "Tequila Shots",
      description: "Ask your server for our extensive list of tequilas. JOSE CUERVO • CAZADORES • PATRON • 1800 • DON JULIO • CABO WABO ...AND MANY MORE & MORE!!!",
      price: ""
    }, {
      id: "whiskeys",
      name: "Whiskeys",
      description: "CHIVAS REGAL • WILD TURKEY • CROWN ROYAL APPLE • CROWN ROYAL • JIM BEAM • JACK DANIEL'S",
      price: ""
    }, {
      id: "wines",
      name: "Wines",
      description: "SANGRIA • CHABLIS • ROSE • MERLOT • CHARDONNAY",
      price: "5.75"
    }]
  }];
  return <section className="bg-background py-16 sm:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
              Our Menu Categories
            </h2>
            <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
              Explore our delicious selection of authentic Mexican dishes, from sizzling fajitas to refreshing margaritas
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {categories.map((category, i) => {
            const IconComponent = category.icon;
            return <AccordionItem key={category.id} value={category.id} data-index={i} className="bg-muted-light-background rounded-lg shadow-soft border-0 overflow-hidden hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                  <AccordionTrigger className="px-6 py-5 hover:no-underline group">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-foreground transition-colors duration-[var(--duration-medium)]">
                        <IconComponent className="w-5 h-5" />
                      </div>
                      <span className="text-lg font-semibold text-foreground text-left">
                        {category.title}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-6">
                    {category.menuItems ? <div className="space-y-6">
                        {category.menuItems.map((item, idx) => <div key={item.id} data-index={idx} className="space-y-2">
                            <h4 className="text-base font-bold text-foreground uppercase">
                              {item.name}
                            </h4>
                            {item.description && <p className="text-sm text-muted-foreground leading-relaxed">
                                {item.description}
                              </p>}
                            <div className="flex flex-wrap gap-3 items-center">
                              {item.price ? <span className="text-base font-semibold text-foreground">
                                  ${item.price}
                                </span> : item.prices?.map((priceOption, priceIdx) => <div key={priceIdx} data-index={priceIdx} className="flex items-center gap-2">
                                    <span className="text-sm font-bold text-green-600 uppercase">
                                      {priceOption.size}
                                    </span>
                                    <span className="text-base font-semibold text-foreground">
                                      ${priceOption.amount}
                                    </span>
                                  </div>)}
                            </div>
                          </div>)}
                        <div className="mt-8 pt-6 border-t border-border">
                          <p className="text-xs text-muted-foreground italic">
                            <strong>Health Advisory:</strong> Consuming raw or undercooked eggs, meats, poultry or seafood may increase your risk of foodborne illness.
                          </p>
                        </div>
                      </div> : <p className="text-muted-foreground leading-relaxed">
                        {category.description}
                      </p>}
                  </AccordionContent>
                </AccordionItem>;
          })}
          </Accordion>
        </div>
      </div>
    </section>;
}